import { Form, Input, Button, Spin, Typography, Checkbox } from 'antd';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import useHttpClient from '../../../shared/sendRequest/useHttpClient';
import EndPoints from '../../../shared/endPoints/EndPoints.json';
import { colors } from '../../../shared/styles/baseStyle';
import AuthLayout from '../../../components/AuthLayout/AuthLayout';
import { useAuthFlowContext } from '../../../shared/context/auth-flow-context';
import {
  policyNumberFormItem,
  inputItem,
  termsItem,
  checkBoxText,
  linkColor,
  buttonItem,
  button,
  remindPolicyNumberButton,
  remindPolicyNumberRow
} from './styles';
import './loginPolicyNumber.css';
import AuthCard from '../../../components/AuthCard/AuthCard';

const { Text, Link } = Typography;

export default function LoginPolicyNumber() {
  const { setAuthFlowContextData } = useAuthFlowContext();
  const { sendRequest } = useHttpClient();
  const history = useHistory();
  const [form] = Form.useForm();
  const termsUrl = 'https://www.anytime.gr/short-drive/terms-and-conditions';
  const privacyPolicyUrl =
    'https://www.anytime.gr/privacy-policy#shortdrive_greece';
  const { mutate, isLoading } = useMutation(sendRequest, {
    onSuccess: data => {
      if (data.tempCode) {
        setAuthFlowContextData({
          tempCode: data.tempCode
        });
      }
      if (data.passwordSet) {
        history.push('/login-password');
      } else {
        history.push('/verify-email');
      }
    },
    onSettled: (data, error) => {
      setAuthFlowContextData({
        policyNumber: form.getFieldValue('policyNumber'),
        ...(error && { tempCode: undefined })
      });
      form.resetFields();
    }
  });

  const onFinish = data => {
    mutate({
      endpoint: `${EndPoints.CONTRACT.CONTRACTVALIDATION}?PolicyNumber=${data.policyNumber}`,
      method: 'GET'
    });
  };

  return (
    <AuthLayout>
      <Spin spinning={isLoading} size="large">
        <AuthCard
          title="Είσοδος"
          subtitle="Εισήγαγε τον Αρ. Συμβολαίου σου για να συνεχίσεις"
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.Item
              label={<Text strong>Αριθμός Συμβολαίου</Text>}
              name="policyNumber"
              rules={[
                {
                  required: true,
                  message: 'Παρακαλώ εισάγετε Αριθμό Συμβολαίου'
                },
                {
                  pattern: /^\d{8}$/,
                  message: 'Ο Αριθμός Συμβολαίου πρέπει να είναι 8 ψηφία'
                }
              ]}
              getValueFromEvent={e =>
                e.target.value.replace(/\D/g, '').slice(0, 8)
              }
              style={policyNumberFormItem}
            >
              <Input size="large" style={inputItem} allowClear maxLength={8} />
            </Form.Item>
            <div style={remindPolicyNumberRow}>
              <Button
                type="link"
                style={remindPolicyNumberButton}
                onClick={() => history.push('/remind-policyNumber')}
              >
                Υπενθύμιση Αρ. Συμβολαίου
              </Button>
            </div>
            <Form.Item
              name="termsConditions"
              valuePropName="checked"
              initialValue={false}
              style={termsItem}
            >
              <Checkbox className="circle-checkbox">
                <Text type="secondary" style={checkBoxText}>
                  Έχω διαβάσει και αποδέχομαι τους{' '}
                  <Link href={termsUrl} target="_blank" style={linkColor}>
                    Όρους Χρήσης
                  </Link>{' '}
                  και την{' '}
                  <Link
                    href={privacyPolicyUrl}
                    target="_blank"
                    style={linkColor}
                  >
                    Πολιτική Απορρήτου
                  </Link>
                </Text>
              </Checkbox>
            </Form.Item>

            <Form.Item shouldUpdate style={buttonItem}>
              {() => {
                const policyNumber = form.getFieldValue('policyNumber');
                const isValidPolicy = /^\d{8}$/.test(policyNumber || '');
                const termsChecked = form.getFieldValue('termsConditions');
                const isDisabled = !isValidPolicy || !termsChecked;

                return (
                  <Button
                    htmlType="submit"
                    block
                    size="large"
                    disabled={isDisabled}
                    style={{
                      ...button,
                      background: isDisabled
                        ? colors.disabledGrey
                        : colors.anytimeBlue
                    }}
                  >
                    Επόμενο
                  </Button>
                );
              }}
            </Form.Item>
          </Form>
        </AuthCard>
      </Spin>
    </AuthLayout>
  );
}
